export function prepareLinkUrl(url: string): string {
  return /^(https?:)?\/\//i.test(url) ? url : '//' + url;
}
